<template>
  <div id="smartTown" class="my-develop">
    <h1 class="dev-title">公司动态</h1>
    <p class="dev-subtitle">
  
    </p>

    <!-- 概览统计（随数据自动计算） -->
    <div class="dev-stats">
      <div class="dev-stat">
        <div class="dev-stat-num">
          {{ total }}<span class="dev-stat-unit">项</span>
        </div>
        <div class="dev-stat-label">发展历程</div>
      </div>
      <div class="dev-stat">
        <div class="dev-stat-num dev-stat-num--text">{{ yearRange }}</div>
        <div class="dev-stat-label">跨越年份</div>
      </div>
      <div class="dev-stat">
        <div class="dev-stat-num">
          {{ milestoneCount }}<span class="dev-stat-unit">个</span>
        </div>
        <div class="dev-stat-label">关键里程碑</div>
      </div>
    </div>

    <!-- 时光墙 -->
    <div class="timeline">
      <div v-for="group in groups" :key="group.year" class="tl-group">
        <div class="tl-year">
          <span class="tl-year-pill">{{ group.year }}</span>
        </div>

        <div
          v-for="item in group.items"
          :key="item.year + '-' + item.month + '-' + item.title"
          class="tl-item"
          :class="{ 'tl-item--right': item._side === 'right', 'is-milestone': item.milestone }"
        >
          <span class="tl-node" aria-hidden="true"></span>
          <article class="tl-card">
            <time class="tl-date" :datetime="datetimeOf(item)">
              {{ item.year }}.{{ pad(item.month) }}
            </time>
            <h2 class="tl-card-title">{{ item.title }}</h2>
            <span v-if="item.category === 'milestone'" class="tl-chip tl-milestone-chip">{{ categoryLabel(item.category) }}</span>
            <template v-else>
              <span class="tl-chip">{{ categoryLabel(item.category) }}</span>
              <span v-if="item.milestone" class="tl-chip tl-milestone-chip">里程碑</span>
            </template>
          </article>
        </div>
      </div>

      <!-- 预留：后续新增动态承接区 -->
      <div class="tl-upcoming">
        <span class="tl-node tl-node--more" aria-hidden="true"></span>
        <div class="tl-card tl-card--more">
          <h2 class="tl-card-title">更多动态持续更新中</h2>
          <p class="tl-card-more-text">
            海南华德科技有限公司将持续在医疗健康、电子政务、数字企业三大领域深耕，
            新的资质认证、战略合作与技术创新成果将在此陆续发布。
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { companyEvents, groupByYear, CATEGORIES } from "@/assets/data/companyEvents.js";

export default {
  name: "myDevelop",
  computed: {
    /** 按年份分组，并按全局顺序标记左右侧，保证中轴交替连续。
     *  ⚠️ 时间倒序（最新在最前）：年份降序，同年内月份降序。
     *  groupByYear() 内部按年份【升序】返回分组，所以分组后必须 reverse() 才是倒序；
     *  组内 items 保持传入 list 的顺序，故 list 按月份降序排即可让同年也是最新在前。 */
    groups() {
      const list = companyEvents.slice().sort((a, b) => {
        if (a.year !== b.year) return b.year - a.year;
        return b.month - a.month;
      });
      const grouped = groupByYear(list).reverse();
      let idx = 0;
      grouped.forEach((g) => {
        g.items.forEach((it) => {
          it._side = idx % 2 === 0 ? "left" : "right";
          idx += 1;
        });
      });
      return grouped;
    },
    total() {
      return companyEvents.length;
    },
    milestoneCount() {
      return companyEvents.filter((e) => e.milestone).length;
    },
    yearRange() {
      if (!companyEvents.length) return "";
      const years = companyEvents.map((e) => e.year);
      const min = Math.min.apply(null, years);
      const max = Math.max.apply(null, years);
      return min === max ? String(min) : min + "—" + max;
    },
  },
  methods: {
    pad(n) {
      return n < 10 ? "0" + n : String(n);
    },
    datetimeOf(item) {
      return item.year + "-" + this.pad(item.month);
    },
    categoryLabel(key) {
      return CATEGORIES[key] ? CATEGORIES[key].label : "其他";
    },
  },
};
</script>

<style scoped>
.my-develop {
  max-width: 1200px;
  margin: 0 auto;
  padding: 32px 20px 44px;
  box-sizing: border-box;
  background: var(--white, #fff);
}

/* ===== 标题区 ===== */
.dev-title {
  position: relative;
  font-size: 28px;
  font-weight: 700;
  color: var(--text-color, #18212e);
  text-align: center;
  margin: 0 0 12px;
  padding-bottom: 16px;
}

.dev-title::after {
  content: "";
  position: absolute;
  left: 50%;
  bottom: 0;
  width: 56px;
  height: 4px;
  margin-left: -28px;
  background: var(--primary-color1, rgb(230, 0, 76));
  border-radius: 2px;
}

.dev-subtitle {
  text-align: center;
  font-size: 15px;
  line-height: 1.8;
  color: var(--text-color2, #676767);
  margin: 0 0 20px;
}

/* ===== 概览统计 ===== */
.dev-stats {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 16px;
  margin-bottom: 28px;
}

.dev-stat {
  flex: 1 1 200px;
  max-width: 280px;
  background: var(--light-bg, #f8f8f8);
  border-radius: 12px;
  padding: 20px 16px;
  text-align: center;
  box-sizing: border-box;
}

.dev-stat-num {
  font-size: 30px;
  font-weight: 700;
  line-height: 1.2;
  color: var(--primary-color1, rgb(230, 0, 76));
}

.dev-stat-num--text {
  font-size: 24px;
}

.dev-stat-unit {
  font-size: 14px;
  font-weight: 400;
  margin-left: 3px;
  color: var(--text-color2, #676767);
}

.dev-stat-label {
  margin-top: 6px;
  font-size: 14px;
  color: var(--text-color2, #676767);
}

/* ===== 时光墙：中轴 ===== */
.timeline {
  position: relative;
  padding: 8px 0 0;
}

.timeline::before {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  left: 50%;
  width: 2px;
  margin-left: -1px;
  background: linear-gradient(
    180deg,
    rgba(230, 0, 76, 0.05) 0%,
    rgba(230, 0, 76, 0.35) 8%,
    rgba(230, 0, 76, 0.35) 92%,
    rgba(230, 0, 76, 0.05) 100%
  );
}

/* 年份锚点 */
.tl-year {
  position: relative;
  text-align: center;
  margin: 0 0 10px;
}

.tl-year-pill {
  display: inline-block;
  padding: 6px 22px;
  border-radius: 999px;
  background: var(--primary-color1, rgb(230, 0, 76));
  color: #fff;
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 1px;
  box-shadow: 0 4px 12px rgba(230, 0, 76, 0.24);
}

/* 条目：左右各占 50% */
.tl-item {
  position: relative;
  width: 50%;
  box-sizing: border-box;
  padding-right: 44px;
  margin-bottom: 12px;
}

.tl-item--right {
  margin-left: 50%;
  padding-right: 0;
  padding-left: 44px;
}

/* 节点（统一品牌色，里程碑加大 + 光晕） */
.tl-node {
  position: absolute;
  top: 15px;
  right: -7px;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: var(--primary-color1, rgb(230, 0, 76));
  box-shadow: 0 0 0 4px var(--primary-opcaity, rgba(230, 0, 76, 0.1));
  box-sizing: border-box;
}

.tl-item--right .tl-node {
  right: auto;
  left: -7px;
}

.is-milestone .tl-node {
  width: 22px;
  height: 22px;
  top: 11px;
  right: -11px;
  box-shadow: 0 0 0 6px var(--primary-opcaity, rgba(230, 0, 76, 0.1)),
    0 0 12px rgba(230, 0, 76, 0.45);
}

.tl-item--right.is-milestone .tl-node {
  right: auto;
  left: -11px;
}

/* 卡片：沿用官网卡片规范 */
.tl-card {
  position: relative;
  background: var(--white, #fff);
  border-radius: 12px;
  padding: 12px 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  box-sizing: border-box;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.tl-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.09);
}

.is-milestone .tl-card {
  border-top: 3px solid var(--primary-color1, rgb(230, 0, 76));
}

.tl-date {
  display: inline-block;
  font-size: 14px;
  font-weight: 600;
  color: var(--primary-color1, rgb(230, 0, 76));
  letter-spacing: 0.5px;
  margin-bottom: 4px;
}

.tl-card-title {
  font-size: 16px;
  font-weight: 600;
  line-height: 1.6;
  color: var(--text-color, #18212e);
  margin: 0 0 8px;
}

/* 分类标签：中性色，不参与配色竞争 */
.tl-chip {
  display: inline-block;
  padding: 3px 12px;
  border-radius: 999px;
  background: var(--light-bg, #f8f8f8);
  border: 1px solid var(--primary-color1, rgb(230, 0, 76));
  color: var(--text-color2, #676767);
  font-size: 12px;
  line-height: 1.6;
}

/* 里程碑标记：品牌色实底（背景色），独立于分类 chip 叠加显示，作为最高强调层级 */
.tl-milestone-chip {
  background: var(--primary-color1, rgb(230, 0, 76));
  color: #fff;
  border: 1px solid var(--primary-color1, rgb(230, 0, 76));
  font-weight: 600;
}
.tl-chip + .tl-milestone-chip {
  margin-left: 8px;
}

/* ===== 预留：持续更新 ===== */
.tl-upcoming {
  position: relative;
  width: 50%;
  box-sizing: border-box;
  padding-right: 44px;
  margin-top: 0;
}

.tl-node--more {
  top: 12px;
  right: -13px;
  width: 26px;
  height: 26px;
  background: var(--white, #fff);
  border: 2px dashed var(--primary-color1, rgb(230, 0, 76));
  color: var(--primary-color1, rgb(230, 0, 76));
  box-shadow: none;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  line-height: 1;
}

.tl-node--more::before {
  content: "+";
}

.tl-card--more {
  background: transparent;
  border: 1px dashed rgba(0, 0, 0, 0.14);
  box-shadow: none;
  text-align: left;
}

.tl-card--more:hover {
  transform: none;
  box-shadow: none;
  border-color: rgba(230, 0, 76, 0.35);
}

.tl-card-more-text {
  font-size: 14px;
  line-height: 1.8;
  color: var(--text-color2, #676767);
  margin: 0;
  text-align: justify;
}

/* ===== 响应式：窄屏切单侧 ===== */
@media screen and (max-width: 991px) {
  .tl-item,
  .tl-item--right,
  .tl-upcoming {
    width: 100%;
    margin-left: 0;
    padding-right: 0;
    padding-left: 46px;
  }

  .timeline::before {
    left: 15px;
    margin-left: 0;
  }

  .tl-node,
  .tl-item--right .tl-node {
    left: 8px;
    right: auto;
  }

  .is-milestone .tl-node,
  .tl-item--right.is-milestone .tl-node {
    left: 4px;
    right: auto;
  }

  .tl-node--more {
    left: 2px;
    right: auto;
  }

  .tl-year {
    text-align: left;
    margin-bottom: 12px;
  }

  .tl-year-pill {
    margin-left: 46px;
  }
}

@media screen and (max-width: 576px) {
  .my-develop {
    padding: 28px 14px 44px;
  }

  .dev-title {
    font-size: 22px;
  }

  .dev-stat {
    flex: 1 1 100%;
    max-width: none;
  }

  .tl-item,
  .tl-item--right,
  .tl-upcoming {
    padding-left: 38px;
  }

  .timeline::before {
    left: 11px;
  }

  .tl-node,
  .tl-item--right .tl-node {
    left: 4px;
  }

  .is-milestone .tl-node,
  .tl-item--right.is-milestone .tl-node {
    left: 0;
  }

  .tl-node--more {
    left: -2px;
  }

  .tl-year-pill {
    margin-left: 38px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/myDevelop.vue